import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Filter chips for Stock Category (Material / Consumable / PPE / Tool + any
 * quick-added ones like Pads, Gloves, Sanitiser). Mirrors MaterialChips.
 *
 * value === "all" | one of the category names.
 * Click an active chip again to clear the filter (returns to "all").
 *
 * Optional `relevantNames` — only categories present on visible items are
 * shown. Auto-resets to "all" if the current selection drops out of scope.
 *
 * Renders nothing if there are 0 or 1 distinct categories in scope (single
 * category = no drill-down needed).
 */
const CategoryChips = ({ value, onChange, testidPrefix = "cat", relevantNames }) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api
      .get("/stock-categories")
      .then((r) => setCategories(r.data || []))
      .catch(() => setCategories([]));
  }, []);

  const visible = relevantNames
    ? categories.filter((c) => relevantNames.includes(c.name))
    : categories;

  // If the active filter is no longer in scope, clear it.
  useEffect(() => {
    if (value !== "all" && relevantNames && !relevantNames.includes(value)) {
      onChange("all");
    }
  }, [value, relevantNames, onChange]);

  if (visible.length < 2) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testidPrefix}-chips`}>
      {visible.map((c) => {
        const active = value === c.name;
        return (
          <button
            key={c.name}
            data-testid={`${testidPrefix}-${c.name}`}
            onClick={() => onChange(active ? "all" : c.name)}
            type="button"
            aria-pressed={active}
            className={`nb-btn px-3 py-1.5 text-sm transition-all ${
              active ? "nb-btn-dark" : "bg-white"
            }`}
          >
            {c.name}
          </button>
        );
      })}
    </div>
  );
};

export default CategoryChips;
